import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { CMSService } from '../../../services/cms-service';

@Component({
  selector: 'app-lutte-contre-epidemie',
  templateUrl: './lutte-contre-epidemie.component.html',
  styleUrls: ['./lutte-contre-epidemie.component.scss']
})
export class LutteContreEpidemieComponent implements OnInit {
  urllogoIec = environment.urllogoIec;
  gesteBarriere: any;
  getImgDesafection: any;
  mode_epidemie: number = 1;
  titre_epidemie :  string = "Désinfection"
  constructor(public cmsService: CMSService, ) { }

  ngOnInit() {
    this.getDesafection();
  }

  getDesafection() {
    this.cmsService.getDesafection("D")
      .subscribe(data => {
        this.getImgDesafection = data
      },
        err => {
          console.log(err);
        })
  }

  open(id_civ : number) {
    if (id_civ == 1) {
      this.mode_epidemie = 1;
      this.titre_epidemie = "Désinfection"
    } else {
      this.getGesteBarriere();
      this.titre_epidemie = "CMS face au COVID-19"
      this.mode_epidemie = 2;
      
    }

  }


  getGesteBarriere() {
    this.cmsService.getDesafection("CMS")
      .subscribe(data => {
        this.gesteBarriere = data
      },
        err => {
          console.log(err);
        })
  }


}
